import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import numeral from "numeral";

const styles = StyleSheet.create({
  body: {
    paddingTop: 40,
    paddingBottom: 40,
    paddingLeft: 30,
    paddingRight: 20
  },
  title: {
    marginBottom: 3,
    fontSize: 18,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  text: {
    margin: 1,
    fontSize: 10,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  //TABLE-----------------------
   table: {
    width: '100%',
    top: 15,
    paddingBottom: 40
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  borderBottom: {
    borderBottom: '1 solid #0000'
  },
  bold: {
    fontWeight: 'bold',
  },
  rowText: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    fontWeight: 'bold',
  },
  alignLeft: {
    textAlign: 'left'
  },
  alignCenter: {
    textAlaign: 'center'
  },
  alignRight: {
    textAlign: 'right'
  },
  paddingNotes: {
    paddingBottom: 40
  },
  // So Declarative and unDRY 👌
  row1: {
    width: '15%',
  },
  row2: {
    width: '10%',
  },
  row3: {
    width: '15%',
  },
  row4: {
    width: '40%',
  },
  row5: {
    width: '10%',
  },
  row6: {
    width: '10%',
  },
});



const PDFPOReceive = ({ dateOfDel, delTo, mop, contact, address, pono, items, notes, shipping, subtotal, grandTotal, encoder, approver }) => {

  return (
    <Document>
      <Page style={styles.body}>
        {/* <Text style={styles.header} fixed>qweqwe</Text> */}
        <Text style={styles.title}>
          Purchase Order Receive Form
        </Text>
        
        <Text style={styles.text}>
          PO No: #{pono}
        </Text>
        <Text style={styles.text}>
          Purchased From: {delTo.toUpperCase()}
        </Text>
        <Text style={styles.text}>
          PO Date: {dateOfDel}
        </Text>
        <Text style={styles.text}>
          Mode of Payment: {mop}
        </Text>
        <Text style={styles.text}>
          Contact Number: {contact}
        </Text>
        <Text style={styles.text}>
          Address: {address}
        </Text>
        
        {/* TABLE */}
        <View style={styles.table}>
          <View style={[styles.row, styles.rowText, styles.borderBottom]}>
            <Text style={[styles.row1, styles.rowText, styles.alignLeft]}>DATE</Text>
            <Text style={[styles.row2, styles.rowText, styles.alignLeft]}>RECIEVE#</Text>
            <Text style={[styles.row3, styles.rowText, styles.alignLeft]}>REFRENCE #</Text>
            <Text style={[styles.row4, styles.rowText, styles.alignLeft]}>ITEM NAME</Text>
            <Text style={[styles.row5, styles.rowText, styles.alignRight]}>QTY</Text>
            <Text style={[styles.row6, styles.rowText, styles.alignRight]}>UNIT</Text>
          </View>
          {items ? items.map((row, i) => (
            <View key={i} style={styles.row} wrap={false}>
              <Text style={[styles.row1, styles.rowText, styles.alignLeft]}>{row.rcv_date}</Text>
              <Text style={[styles.row2, styles.rowText, styles.alignLeft]}>#{row.rcv_no}</Text>
              <Text style={[styles.row3, styles.rowText, styles.alignLeft]}>{row.ref_no}</Text>
              <Text style={[styles.row4, styles.rowText, styles.alignLeft]}>{row.item_name}</Text>
              <Text style={[styles.row5, styles.rowText, styles.alignRight]}>{row.qty_received}</Text>
              <Text style={[styles.row6, styles.rowText, styles.alignRight]}>{row.uomDesc}</Text>
            </View>
          )) : ''}
      </View>

      {/* TOTALITIES */}
      {/* <Text style={[styles.text,styles.alignRight]}>
          Shipping: {shipping}
      </Text> */}
      {/* <Text style={[styles.text,styles.alignRight]}>
          Sub-Total: {subtotal}
      </Text>
      <Text style={[styles.text,styles.alignRight]}>
          Total: {grandTotal}
      </Text> */}

      {/* NOTES */}
      {/* <Text style={[styles.text,styles.alignLeft]}>
          **Notes**:
      </Text>
      <Text style={[styles.text,styles.alignLeft,styles.paddingNotes]}>
        {notes}
      </Text> */}

      {/* Encoded */}
      {/* <Text style={[styles.text,styles.alignLeft]}>
          |Encoded By: {encoder}
      </Text>
      <Text style={[styles.text,styles.alignLeft]}>
          |Approved By: {approver}
      </Text> */}


        <Text 
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => (
          `${pageNumber} / ${totalPages}`
        )} fixed />
      </Page>
    </Document>
  );
};

export default PDFPOReceive;